import type { DocumentTitleEnvironmentLabel } from '../../environments/environment.model';

export const APP_DOCUMENT_TITLE_BASE = 'Momentum';

export interface AppDocumentTitleOptions {
  entityTitle?: string | null;
  environmentLabel?: DocumentTitleEnvironmentLabel;
}

export function buildAppDocumentTitle(
  routeTitle?: string | null,
  options?: AppDocumentTitleOptions,
): string {
  const parts: string[] = [];

  const environmentLabel = options?.environmentLabel;
  if (environmentLabel) {
    parts.push(`(${environmentLabel})`);
  }

  const entity = options?.entityTitle?.trim();
  const route = routeTitle?.trim();
  if (entity) {
    parts.push(entity);
  }
  if (route) {
    parts.push(route);
  }

  parts.push(APP_DOCUMENT_TITLE_BASE);

  return parts.join(' - ');
}
